module.exports = __webpack_public_path__ + "static/media/Muli-Light.0582bd07.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Muli-Light.svg
// module id = 1293
// module chunks = 1